const mutations = {
  
    ADD_FUNCIONARIOS (state, value) {

        state.funcionarios.push(value)

    },
    ALL_FUNCIONARIOS (state, value) {

        state.getfuncionarios = value

    },
    ALL_PROFESSORES (state, value) {

        state.getprofessores = value

    },
    SET_FUNCIONARIO (state, value) {

        state.setFuncionario = value

    },
   
}

export default mutations